import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { faRedo } from '@fortawesome/pro-regular-svg-icons';

// manor
import { Button } from '@comparethemarketau/manor-button';

const useStyles = createUseStyles((theme) => ({
    button: {
        width: '17.3rem',
        height: '4.8rem'
    }
}));

const StartNewQuoteButton = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className } = props;

    const handleClick = () => {
        location.reload();
    };

    return (
        <div className={classNames(className)}>
            <Button
                id={'start-new-quote-button'}
                trackingLabel={'Start new quote'}
                variant="primary"
                handleClick={handleClick}
                iconAlign="right"
                icon={faRedo}
                className={classes.button}
            >
                Start new quote
            </Button>
        </div>
    );
};

StartNewQuoteButton.propTypes = {
    className: PropTypes.string
};

export { StartNewQuoteButton };
